import { useNavigate } from 'react-router-dom';
import '../styles/page.css';
import { useEffect, useState } from 'react';
import { INoticeDetail } from '../../interface/notice';
import AOS from 'aos';
import 'aos/dist/aos.css';

function NoticeDetail() {
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const boardSeq = searchParams.get('boardSeq');

  const [NoticeDetail, setNoticeDetail] = useState<INoticeDetail>();
  const [prevData, setPrevData] = useState<INoticeDetail>();
  const [nextData, setNextData] = useState<INoticeDetail>();

  // 공지사항 목록으로 이동
  const hadleList = () => {
    navigate(`/notice`);
  };

  const handleSearch = async () => {
    await fetch(`/notice/detail?boardSeq=${boardSeq}`, {
      method: 'GET',
      headers: { 'Content-Type': 'applications/json' },
    })
      .then((response) => response.json())
      .then((result) => {
        setNoticeDetail(result);
      })
      .catch((error) => {
        console.error('공지사항 상세화면 조회 실패:', error);
      });
  };

  // 공지사항 '이전글'로 이동
  const handlePrev = () => {
    navigate(`/notice-detail?boardSeq=${prevData?.boardSeq}`);
    navigate(0);
  };

  // 공지사항 '다음글'로 이동
  const handleNext = () => {
    navigate(`/notice-detail?boardSeq=${nextData?.boardSeq}`);
    navigate(0);
  };

  useEffect(() => {
    // 공지사항 이전글/다음글 세팅
    fetch(`/notice/list?searchTitle=`)
      .then((response) => response.json())
      .then((result) => {
        const index = result?.findIndex(
          (item: { boardSeq: string | null }) => item.boardSeq === boardSeq,
        );
        if (index !== -1) {
          const prevObj: INoticeDetail = result[index + 1];
          const nextObj: INoticeDetail = result[index - 1];
          setPrevData(prevObj);
          setNextData(nextObj);
        }
      })
      .catch((error) => {
        console.error('공지사항 상세화면 조회 실패:', error);
      });
  }, [NoticeDetail]);

  useEffect(() => {
    AOS.init();
    handleSearch();
  }, []);

  return (
    <>
      <section id="notice-banner">
        <div className="page-banner-bg">
          <div className="m-auto page-banner-container">
            <h2 data-aos="fade-right" data-aos-duration="700" data-aos-once="true">
              공지사항
            </h2>
            <p
              className="color-caption fs-md"
              data-aos="fade-right"
              data-aos-duration="700"
              data-aos-once="true"
              data-aos-delay="200"
            >
              테이크의 최신 소식을 알려드립니다.
            </p>
          </div>
        </div>
      </section>

      <main id="notice-detail">
        <div className="notice-detail-container m-auto">
          <div className="notice-detail-title">
            <p className="fs-md">{NoticeDetail?.boardTitle}</p>
            <div className="notice-detail-infobox">
              <div className="notice-detail-infotext">
                <span>등록일</span>
                <span>{NoticeDetail?.regDt?.substring(0, 11)}</span>
              </div>
              <div className="notice-detail-infotext">
                <span>조회수</span>
                <span>
                  {NoticeDetail?.readCnt === null || NoticeDetail?.readCnt === undefined
                    ? '1'
                    : Number(NoticeDetail?.readCnt) + 1}
                </span>
              </div>
            </div>
          </div>
          <div className="notice-detail-body">
            {NoticeDetail?.boardTxt
              ?.replace(/<(?!\/p)[^>]+>/g, '')
              .replaceAll('</p>', '\n')
              .replaceAll('&nbsp;', '')}
          </div>
          <div className="notice-nav-box">
            <div className="notice-nav">
              <div className="notice-nav-head">
                <span className="mr-4">이전글</span>
                <img src="./images/ico-notice-up.svg" alt="" />
              </div>
              <div className="notice-nav-body">
                {undefined !== prevData ? (
                  <a className="" onClick={handlePrev}>
                    {prevData?.boardTitle}
                  </a>
                ) : (
                  <a className="">-</a>
                )}
              </div>
            </div>
            <div className="notice-nav">
              <div className="notice-nav-head">
                <span className="mr-4">다음글</span>
                <img src="./images/ico-notice-down.svg" alt="" />
              </div>
              <div className="notice-nav-body">
                {undefined !== nextData ? (
                  <a className="" onClick={handleNext}>
                    {nextData?.boardTitle}
                  </a>
                ) : (
                  <a className="">-</a>
                )}
              </div>
            </div>
          </div>
          <div className="notice-btn-box">
            <button type="button" onClick={hadleList}>
              목록으로
            </button>
          </div>
        </div>
      </main>
    </>
  );
}

export default NoticeDetail;
